import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Badge } from 'reactstrap';
import { returnParamiters, returnStatus } from '../relatorio.utils';
import * as actions from '../relatorio.action';
import * as commonActions from '@common/common.action';
import RelatorioApi from '../relatorio.api';
import ModalRegistroDeContato from './RegistroDeContato';
import Filtro from './Filtro';
import Grid from './Grid';
import RelatorioNotificacao from './Relatorios/Notificacao';
import RelatorioLaudosCriticos from './Relatorios/LaudosCriticos';
import IntlMessage from '../../../helpers/intlMessage';
import CommonFunctions from '@util/functions.common';
import { useIntl } from 'react-intl';

function LaudoCritico ({ showMessageByResults }) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [filtro, setFiltro] = useState({});
  const [lista, setLista] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagina, setPagina] = useState(1);
  const [showBtnImprimir, setShowBtnImprimir] = useState(false);
  const [showModalRegistro, setShowModalRegistro] = useState(false);
  const [showModalImprimir, setShowModalImprimir] = useState(false);
  const [showModalImprimirNotificacoes, setShowModalImprimirNotificacoes] = useState(false);

  useEffect(() => {
    const { tipo } = filtro;
    tipo && filtrar(filtro);
  }, [pagina]);

  useEffect(() => {
    setShowBtnImprimir(false);
  }, [filtro]);

  const oncClickImprimirNotificacoes = item => {
    dispatch(actions.laudoSelecionado(item));
    setShowModalImprimirNotificacoes(true);
  };

  const onclickLine = item => {
    dispatch(actions.laudoSelecionado(item.data));
    setShowModalRegistro(true);
  };

  const filtrar = async filtro => {
    const { medico, periodoInicial, periodoFinal, tipo, value } = filtro;

    let params = returnParamiters({
      periodoInicial,
      periodoFinal,
      tipo,
      value
    });

    let executarValidacaoDeData = (filtro.tipo.indexOf('dt') >= 0);
    let result = {valid: true, message: ''};

    if (executarValidacaoDeData)
      result = CommonFunctions.validaData(periodoInicial, periodoFinal, intl, commonActions);

    if (!result.valid) {
      dispatch(commonActions.showAlerta('alerta', result.message, 3000));
      return;
    }

    if (medico) params.medicoSolicitante = medico;

    dispatch(commonActions.showFadeCarregando(true));
    const response = await RelatorioApi.getLaudos(pagina, params);
    pagina === 1 && setTotal(response.total);

    setLista(formatItens(response.listagem));
    setShowBtnImprimir(response.listagem.length > 0);
    dispatch(commonActions.showFadeCarregando(false));

    if (response.listagem.length === 0)
      dispatch(commonActions.showAlerta('alerta', <IntlMessage id="dashboards.reports.noResultsFound" />, 3000));
  };

  const formatItens = lista => {
    return lista.map(item => {
      const { backgroundColor, color, label } = returnStatus(item);
      return {
        ...item,
        statusFormatted: (
          <Badge style={{ fontSize: '12px', backgroundColor, color }}>
            {label}
          </Badge>
        )
      };
    });
  };

  return (
    <div>
      <RelatorioLaudosCriticos
        filtro={filtro}
        total={total}
        lista={lista}
        setShowModalImprimir={setShowModalImprimir}
        showModalImprimir={showModalImprimir}
      />
      <RelatorioNotificacao
        filtro={filtro}
        setShowModalImprimir={setShowModalImprimirNotificacoes}
        showModalImprimir={showModalImprimirNotificacoes}
      />
      <ModalRegistroDeContato
        onModal={() => setShowModalRegistro(!showModalRegistro)}
        showModal={showModalRegistro}
        showMessageByResults={showMessageByResults}
      />
      <Filtro
        setFiltro={setFiltro}
        filtro={filtro}
        filtrar={filtrar}
        showBtnImprimir={showBtnImprimir}
        setShowModalImprimir={setShowModalImprimir}
      />
      {!!lista.length && (
        <Grid
          lista={lista}
          totalItens={total}
          pagina={pagina}
          totalItensPage={20}
          setPagina={setPagina}
          oncClickImprimirNotificacoes={oncClickImprimirNotificacoes}
          onclickLine={onclickLine}
        />
      )}
      {!lista.length && (
        <div className='icone-semdados'>
          <i className='inicial-icons fas fa-plus-circle'></i>
        </div>
      )}
    </div>
  );
}

export default LaudoCritico;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoCritico/index.js